import React from 'react';
import Toggle from 'react-toggle';
import styles from './Toggle.scss';

export default ({ isLoading, ...rest }) => (
  <Toggle
    disabled={isLoading}
    className={isLoading ? 'is-loading' : ''}
    {...rest}
  />
);
